'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Extend = require('./util/extend');
var isSupported = require('./util/ls')();
var Ajax = require('./xhr');
var Logger = require('./util/logger');
var sdkVersion = require('./constant/version').version;
var Url = require('./util/url');

var protocol = window.location.protocol ? window.location.protocol : 'http:';
var urlProduct = protocol + '//catfront.dianping.com';
var urlBeta = protocol + '//catfront.51ping.com';
var KEY_CONFIG = 'owl_config';
var CACHE_TIME = 1000 * 60 * 60;
var EXT = ['region', 'operator', 'network', 'container', 'os', 'unionId'];

/**
 * 配置管理类
 * 
 * @class CfgManager
 */

var CfgManager = function () {
    /**
     * Creates an instance of CfgManager.
     * @param {Object} config 
     * @memberof CfgManager
     */
    function CfgManager(config) {
        _classCallCheck(this, CfgManager);

        this.url = urlProduct;

        this.filters = [];

        this._config = {
            devMode: false,
            project: '',
            pageUrl: '',
            logan: {
                enable: false
            },
            disabledFilters: [],
            noScriptError: true,
            ignoreList: {
                js: [],
                ajax: ['https?://report.meituan.com/'],
                resource: ['https?://hls.dianping.com/', 'https?://frep.meituan.net/']
            },
            resourceReg: /(.51ping|.dianping|.dpfile|.meituan|.sankuai|.maoyan|.kuxun)/,
            disableCache: false,
            invalid: {
                ajax: true
            },
            autoCatch: {
                page: true,
                ajax: true,
                js: true,
                resource: true
            },
            ajax: {
                flag: false,
                duration: 2000
            },
            image: {
                flag: false,
                duration: 5000,
                fileSize: 100,
                filter: function filter() {
                    return false;
                }
            },
            resource: {
                sample: 0.1,
                sampleApi: 0.1,
                combo: true,
                delay: 1000
            },
            page: {
                auto: true,
                sample: 0.5,
                delay: 0,
                timeThreshold: 5,
                mainResourceNumber: 5
            },
            error: {
                sample: 1,
                delay: 1000,
                combo: false
            },
            metric: {
                sample: 0.5,
                combo: true,
                delay: 1500
            }
        };

        this.baseQuery = {
            v: 1,
            sdk: sdkVersion
        };

        this.apiPaths = {
            log: '/api/log',
            error: '/api/log',
            page: '/api/speed',
            resource: '/api/batch',
            metric: '/api/metric'
        };

        this.extensions = {};

        this.userConfig = {};

        this.config = {};

        if (config) {
            this.set(config);
        } else {
            this.config = this._config;
        }
    }
    /**
     * 移除错误过滤器
     * 
     * @param {string} key 
     * @memberof CfgManager
     */


    _createClass(CfgManager, [{
        key: 'removeFilter',
        value: function removeFilter(key) {
            for (var index = 0; index < this.filters.length; index++) {
                var filter = this.filters[index];
                if (filter.key === key) {
                    this.filters.splice(index, 1);
                    return;
                }
            }
        }
        /**
         * 增加错误过滤器
         * 
         * @param {string} key 
         * @param {Function} fn 
         * @memberof CfgManager
         */

    }, {
        key: 'addFilter',
        value: function addFilter(key, fn) {
            if (key && fn instanceof Function && this.config.disabledFilters && this.config.disabledFilters.indexOf(key) === -1) {
                var filterIndex = -1;
                for (var index = 0; index < this.filters.length; index++) {
                    var filter = this.filters[index];
                    if (filter.key === key) {
                        filterIndex = index;
                        filter.fn = fn;
                    }
                }
                if (filterIndex === -1) {
                    this.filters.push({
                        key: key,
                        fn: fn
                    });
                }
            }
        }
    }, {
        key: 'get',
        value: function get(key) {
            if (key) {
                return this.config[key];
            } else {
                return this.config;
            }
        }
    }, {
        key: 'set',
        value: function set(data) {
            for (var key in data) {
                if (data.hasOwnProperty(key)) {
                    if (key === 'devMode') {
                        this.setApiDomain(data[key]);
                    }
                    if (key === 'ext') {
                        this.setExtension(data[key]);
                    }
                    if (key === 'resourceReg') {
                        try {
                            this.userConfig[key] = new RegExp(data[key]);
                        } catch (e) {
                            Logger.ignore(e);
                        }
                    }
                    // 合并其他配置项，支持二级对象
                    if (_typeof(data[key]) !== 'object' || data[key] instanceof RegExp || data[key] instanceof Array) {
                        this.userConfig[key] = data[key];
                    } else {
                        this.userConfig[key] = Extend(this.userConfig[key], data[key]);
                    }
                }
            }
            this.update();
        }
    }, {
        key: 'setApiDomain',
        value: function setApiDomain(isDev) {
            if (isDev) {
                this.url = urlBeta;
            } else {
                this.url = urlProduct;
            }
        }
    }, {
        key: 'getApiDomain',
        value: function getApiDomain() {
            return this.url;
        }
        /**
         * 获得数据的维度信息
         */

    }, {
        key: 'getExtension',
        value: function getExtension(key) {
            return key ? this.extensions[key] : this.extensions;
        }
        /**
         * 设置数据的维度信息
         */

    }, {
        key: 'setExtension',
        value: function setExtension(object) {
            for (var key in object) {
                if (object.hasOwnProperty(key)) {
                    var value = object[key];
                    if (key === 'latlng') {
                        // 修改url参数声明使用经纬度替换region
                        this.extensions['region'] = value;
                        this.baseQuery['useLatlng'] = true;
                    } else if (EXT.indexOf(key) !== -1) {
                        this.extensions[key] = value;
                    }
                }
            }
        }
    }, {
        key: 'getApiPath',
        value: function getApiPath(key) {
            var path = this.apiPaths[key];
            return Url.stringify(this.url + path, this.baseQuery);
        }
    }, {
        key: 'update',
        value: function update() {
            //只更新两级对象
            this.config = this._config;
            for (var key in this.userConfig) {
                var data = this.userConfig[key];
                if ((typeof data === 'undefined' ? 'undefined' : _typeof(data)) != 'object' || data instanceof RegExp || data instanceof Array) {
                    this.config[key] = data;
                } else {
                    this.config[key] = Extend(this.config[key], this.userConfig[key]);
                }
            }
        }
    }, {
        key: 'reset',
        value: function reset() {
            this.config = this._config;
        }
    }, {
        key: '_setDefault',
        value: function _setDefault(config) {
            //config的值只能是基本类型，对象，数组
            if (!config) return;
            if (config.resourceReg) {
                config.resourceReg = new RegExp(config.resourceReg);
            }
            for (var key in config) {
                if (config.hasOwnProperty(key)) {
                    var data = config[key];
                    if ((typeof data === 'undefined' ? 'undefined' : _typeof(data)) != 'object' || data instanceof RegExp || data instanceof Array) {
                        this._config[key] = data;
                    } else {
                        this._config[key] = Extend(this.config[key], data);
                    }
                }
            }
            // this._config = Extend(this._config, config)
            this.update();
        }
        /**
         * 访问远程API判断配置是否需要更新
         * 
         * @memberof CfgManager
         */

    }, {
        key: 'checkUpdate',
        value: function checkUpdate() {
            var _this = this;

            try {
                var cachedConfig = this.initFromCache();
                if (cachedConfig) {
                    var delay = cachedConfig.delay || CACHE_TIME;
                    if (+new Date() - cachedConfig.ts > delay || Object.keys(cachedConfig).length === 0) {
                        Ajax({
                            url: this.url + '/api/config',
                            success: function success(res) {
                                if (res) {
                                    _this.updateCache(res.config, res.md5, res.delay);
                                    _this._setDefault(res.config);
                                } else {
                                    //返回值为空时，清空缓存
                                    _this.clearCache();
                                }
                            },
                            fail: function fail() {
                                _this._setDefault(cachedConfig.config);
                            }
                        });
                    } else {
                        this._setDefault(cachedConfig.config);
                    }
                }
            } catch (e) {
                Logger.ignore(e);
            }
        }
        /**
         * 更新最新远程配置到本地存储
         * 
         * @param {Object} config 
         * @param {string} md5 
         * @param {Number} delay 
         * @memberof CfgManager
         */

    }, {
        key: 'updateCache',
        value: function updateCache(config, md5, delay) {
            if (!config) return;
            var cachedConfig = {
                config: config,
                ts: +new Date(),
                md5: md5,
                delay: delay || CACHE_TIME
            };

            if (isSupported) {
                try {
                    window.localStorage.setItem(KEY_CONFIG, JSON.stringify(cachedConfig));
                } catch (e) {
                    Logger.ignore(e);
                }
            }
        }
        /**
         * 清空配置缓存
         * 
         * @memberof CfgManager
         */

    }, {
        key: 'clearCache',
        value: function clearCache() {
            if (isSupported) {
                try {
                    window.localStorage.removeItem(KEY_CONFIG);
                } catch (e) {
                    Logger.ignore(e);
                }
            }
        }
        /**
         * 读取配置缓存
         * 
         * @returns 
         * @memberof CfgManager
         */

    }, {
        key: 'initFromCache',
        value: function initFromCache() {
            // undefined代表不支持，空对象代表没有数据
            var cachedConfig = undefined;
            if (isSupported) {
                try {
                    cachedConfig = window.localStorage.getItem(KEY_CONFIG);
                    if (cachedConfig) {
                        cachedConfig = JSON.parse(cachedConfig);
                    } else {
                        cachedConfig = {};
                    }
                } catch (e) {
                    cachedConfig = {};
                    Logger.ignore(e);
                }
            }
            return cachedConfig;
        }
    }]);

    return CfgManager;
}();

module.exports = CfgManager;


//////////////////
// WEBPACK FOOTER
// ./~/@dp/owl/lib/config.js
// module id = 243
// module chunks = 0